<div id="ExchangeItems" class="page-layout blank" class="page-layout simple" fxLayout="column">
  <div class="content-card" fxFill>
    <div class="content">
      <div class="row general-content">
        <div fxFlex="70" class="user-interface">
          <div class="row">
            <div fxLayoutAlign="end center" class="add-button-container">
              <ng-content></ng-content>
              <button mat-button color="accent" class="add-button" (click)="createExchangeItem()">
                {{ ExchangeType+'-MANAGEMENT.ADDBTN' | translate }}
                @if(ExchangeType === 'TEAM'){
                  @if(isClassTeams) {
                    {{ 'TEAMS-ADD-FORM.CLASS' | translate }}
                  } @else {
                    {{ 'TEAMS-ADD-FORM.STANDARD' | translate }}
                  }
                }
              </button>
            </div>
            @if(!isLoading){
              @if(!hasNoExchangeItems){
              <div class="mat-elevation-z8">
                <table id="gridContainer" mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
                  <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="state" class="sortable">
                      {{ 'TABLE.MANAGEMENT.'+ExchangeType+'.HEADER.STATUS' | translate }}
                      <mat-icon class="sort-icon">sort</mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @switch(element.state){
                      @case (exchangeStatus.ERROR) {
                      <div class="current-value error-tag">
                        {{ 'TABLE.MANAGEMENT.STATUS.ERROR' | translate }}
                      </div>
                      }
                      @case (exchangeStatus.CREATE) {
                      <div class="current-value create-tag">
                        {{ 'TABLE.MANAGEMENT.STATUS.CREATE' | translate }}
                      </div>
                      }
                      @case (exchangeStatus.UPTODATE) {
                      <div class="current-value success-tag">
                        {{ 'TABLE.MANAGEMENT.STATUS.FINISHED' | translate }}
                      </div>
                      }
                      @case (exchangeStatus.DELETE) {
                      <div class="current-value error-tag">
                        {{ 'TABLE.MANAGEMENT.STATUS.DELETE' | translate }}
                      </div>
                      }
                      @case (exchangeStatus.MODIFY) {
                      <div class="current-value waiting-tag">
                        {{ 'TABLE.MANAGEMENT.STATUS.WAITING' | translate }}
                      </div>
                      }
                      @default {
                      <div class="current-value waiting-tag">
                        {{ 'TABLE.MANAGEMENT.STATUS.WAITING' | translate }}
                      </div>
                      }
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="displayName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="displayName" class="sortable">
                      {{ 'TABLE.MANAGEMENT.'+ExchangeType+'.HEADER.NAME' | translate }}
                      <mat-icon class="sort-icon">sort</mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.displayName }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="type" class="sortable">
                      {{ 'TABLE.MANAGEMENT.'+ExchangeType+'.HEADER.TYPE' | translate }}
                      <mat-icon class="sort-icon">sort</mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @switch(element.type){
                      @case('s') {
                      <div class="current-value">
                        {{ 'TABLE.MANAGEMENT.TYPE.SALLE' | translate }}
                      </div>
                      }
                      @case('z') {
                      <div class="current-value">
                        {{ 'TABLE.MANAGEMENT.TYPE.SALLE' | translate }}
                      </div>
                      }
                      @case('e') {
                      <div class="current-value">
                        {{ 'TABLE.MANAGEMENT.TYPE.EQUIP' | translate }}
                      </div>
                      }
                      @case('a') {
                      <div class="current-value">
                        {{ 'TABLE.MANAGEMENT.TYPE.AGENDA' | translate }}
                      </div>
                      }
                      @case('cal') {
                      <div class="current-value">
                        {{ 'TABLE.MANAGEMENT.TYPE.CAL' | translate }}
                      </div>
                      }
                      @case('kal') {
                      <div class="current-value">
                        {{ 'TABLE.MANAGEMENT.TYPE.CAL' | translate }}
                      </div>
                      }
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="email" class="sortable">
                      {{ 'TABLE.MANAGEMENT.'+ExchangeType+'.HEADER.MAILBOX' | translate }}
                      <mat-icon class="sort-icon">sort</mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.email }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      @if(element.state === exchangeStatus.UPTODATE && element.entAccessEdit === 'False'){
                      <button mat-button class="view-button" [disabled]="disabledForMaintenance"
                        (click)="redirectSingleExchangeItem(element.id)">
                        <mat-icon>remove_red_eye</mat-icon>
                      </button>
                      }@else if(element.state === exchangeStatus.UPTODATE && element.entAccessEdit === 'True'){
                      <button mat-button class="edit-button" [disabled]="isExchangeItemDisabled"
                        (click)="redirectSingleExchangeItem(element.id)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="view">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      @if(element.state === exchangeStatus.UPTODATE){
                      <button mat-button class="view-button" [disabled]="disabledForMaintenance"
                        (click)="redirectSingleExchangeItem(element.id)">
                        <mat-icon>remove_red_eye</mat-icon>
                      </button>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      @if(element.state === exchangeStatus.UPTODATE && element.entAccesDelete === 'True' &&
                      element.entAccessEdit === 'True'){
                      <button mat-button class="delete-button" (click)="deleteExchangeItem(element)">
                        <mat-icon>delete</mat-icon>
                      </button>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      <button mat-icon-button (click)="toggleRow(element)">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                      <div class="expanded-detail">
                        <div class="hiddenActions">
                          @if(hiddenColumns.includes('view')){
                          @if(element.state === exchangeStatus.UPTODATE){
                          <button mat-button class="view-button" [disabled]="disabledForMaintenance"
                            (click)="redirectSingleExchangeItem(element.id)">
                            <mat-icon>remove_red_eye</mat-icon>
                          </button>
                          }
                          }

                          @if(hiddenColumns.includes('edit')){
                          @if(element.state === exchangeStatus.UPTODATE && element.entAccessEdit === 'False'){
                          <button mat-button class="view-button" [disabled]="disabledForMaintenance"
                            (click)="redirectSingleExchangeItem(element.id)">
                            <mat-icon>remove_red_eye</mat-icon>
                          </button>
                          }@else if(element.state === exchangeStatus.UPTODATE && element.entAccessEdit === 'True'){
                          <button mat-button class="edit-button" [disabled]="isExchangeItemDisabled"
                            (click)="redirectSingleExchangeItem(element.id)">
                            <mat-icon>edit</mat-icon>
                          </button>
                          }
                          }

                          @if(hiddenColumns.includes('delete')){
                          @if(element.state === exchangeStatus.UPTODATE && element.entAccesDelete === 'True' &&
                          element.entAccessEdit === 'True'){
                          <button mat-button class="delete-button" (click)="deleteExchangeItem(element)">
                            <mat-icon>delete</mat-icon>
                          </button>
                          }
                          }
                        </div>

                        @if(hiddenColumns.includes('type')){
                        <div class="hiddenType">
                          <strong>
                            {{ 'TABLE.MANAGEMENT.'+ExchangeType+'.HEADER.TYPE' | translate}}:
                          </strong>
                          @switch(element.type){
                          @case('s') {
                          <div class="current-value">
                            {{ 'TABLE.MANAGEMENT.TYPE.SALLE' | translate }}
                          </div>
                          }
                          @case('z') {
                          <div class="current-value">
                            {{ 'TABLE.MANAGEMENT.TYPE.SALLE' | translate }}
                          </div>
                          }
                          @case('e') {
                          <div class="current-value">
                            {{ 'TABLE.MANAGEMENT.TYPE.EQUIP' | translate }}
                          </div>
                          }
                          @case('a') {
                          <div class="current-value">
                            {{ 'TABLE.MANAGEMENT.TYPE.AGENDA' | translate }}
                          </div>
                          }
                          @case('cal') {
                          <div class="current-value">
                            {{ 'TABLE.MANAGEMENT.TYPE.CAL' | translate }}
                          </div>
                          }
                          @case('kal') {
                          <div class="current-value">
                            {{ 'TABLE.MANAGEMENT.TYPE.CAL' | translate }}
                          </div>
                          }
                          }
                        </div>
                        }

                        @if(hiddenColumns.includes('state')){
                        <div class="hiddenStatus">
                          <strong>
                            {{
                            'TABLE.MANAGEMENT.'+ExchangeType+'.HEADER.STATUS'
                            | translate
                            }}:
                          </strong>
                          @switch(element.state){
                          @case (exchangeStatus.ERROR) {
                          <div class="current-value error-tag">
                            {{ 'TABLE.MANAGEMENT.STATUS.ERROR' | translate }}
                          </div>
                          }
                          @case (exchangeStatus.CREATE) {
                          <div class="current-value create-tag">
                            {{ 'TABLE.MANAGEMENT.STATUS.CREATE' | translate }}
                          </div>
                          }
                          @case (exchangeStatus.UPTODATE) {
                          <div class="current-value success-tag">
                            {{ 'TABLE.MANAGEMENT.STATUS.FINISHED' | translate }}
                          </div>
                          }
                          @case (exchangeStatus.DELETE) {
                          <div class="current-value error-tag">
                            {{ 'TABLE.MANAGEMENT.STATUS.DELETE' | translate }}
                          </div>
                          }
                          @case (exchangeStatus.MODIFY) {
                          <div class="current-value waiting-tag">
                            {{ 'TABLE.MANAGEMENT.STATUS.WAITING' | translate }}
                          </div>
                          }
                          @default {
                          <div class="current-value waiting-tag">
                            {{ 'TABLE.MANAGEMENT.STATUS.WAITING' | translate }}
                          </div>
                          }
                          }
                        </div>
                        }

                        @if(hiddenColumns.includes('email')){
                        <div class="hiddenMail">
                          <strong>
                            {{
                            'TABLE.MANAGEMENT.'+ExchangeType+'.HEADER.MAILBOX'
                            | translate
                            }}:
                          </strong>
                          {{ element.email }}
                        </div>
                        }

                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="
                                            let row;
                                            let index = dataIndex;
                                            columns: displayedColumns" class="element-row"
                    [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                  <tr mat-row *matRowDef="let element; let index = dataIndex; columns: ['expandedDetail']"
                    [class.show-hide]="expandedElement !== element" [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                </table>
                <mat-paginator [hidePageSize]="true" [pageSize]="15" showFirstLastButtons>
                </mat-paginator>
              </div>
              }@else{
              <div id="error-noservice" fxLayout="column" fxLayoutAlign="center center">
                <div class="content" fxLayout="column" fxLayoutAlign="center center">
                  <div class="error-code">
                    {{ ExchangeType+'-MANAGEMENT.NODEMANDS' | translate }}
                  </div>
                </div>
              </div>
              }
            }@else{
              <mat-progress-bar color="accent" mode="indeterminate" class="mat-progress-bar" />
            }
          </div>
        </div>
        <div fxFlex="30" class="info-interface">
          <mat-card class="description-card">
            <h2>{{ ExchangeType+'-MANAGEMENT.DESCRIPTION.TITLE' | translate }}</h2>
            <div class="desc-exchangeitem">
              {{ ExchangeType+'-MANAGEMENT.DESCRIPTION.LINE1' | translate }}
            </div>
            <div class="desc-exchangeitem">
              <strong>
                {{ ExchangeType+'-MANAGEMENT.DESCRIPTION.LINE2' | translate }}
              </strong>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>